import { render, staticRenderFns } from "./SysCategoriaMPPAAutocomplete.vue?vue&type=template&id=2438cdae&scoped=true"
import script from "./SysCategoriaMPPAAutocomplete.vue?vue&type=script&lang=js"
export * from "./SysCategoriaMPPAAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2438cdae",
  null
  
)

export default component.exports